import { createContainerComponent, createDivOverlayComponent, createLeafComponent } from './component';
import { createControlHook } from './control';
import { createElementHook } from './element';
import { createLayerHook } from './layer';
import { createDivOverlayHook } from './div-overlay';
import { createPathHook } from './path';
export function createControlComponent(createInstance) {
  function createElement(props, context) {
    return {
      instance: createInstance(props),
      context: context
    };
  }
  var useElement = createElementHook(createElement);
  var useControl = createControlHook(useElement);
  return createLeafComponent(useControl);
}
export function createLayerComponent(createElement, updateElement) {
  var useElement = createElementHook(createElement, updateElement);
  var useLayer = createLayerHook(useElement);
  return createContainerComponent(useLayer);
}
export function createOverlayComponent(createElement, useLifecycle) {
  var useElement = createElementHook(createElement);
  var useOverlay = createDivOverlayHook(useElement, useLifecycle);
  return createDivOverlayComponent(useOverlay);
}
export function createPathComponent(createElement, updateElement) {
  var useElement = createElementHook(createElement, updateElement);
  var usePath = createPathHook(useElement);
  return createContainerComponent(usePath);
}
export function createTileLayerComponent(createElement, updateElement) {
  var useElement = createElementHook(createElement, updateElement);
  var useLayer = createLayerHook(useElement);
  return createLeafComponent(useLayer);
}